export const table_config = {
  actions: {
    single: () => [[{ label: 'View', value: 'view' }]]
  },
  css: {},
  fields: [
    {
      title: 'First name',
      key: 'firstname',
      isTitle: true,
      searchable: true
    },
    {
      title: 'Last name',
      key: 'lastname',
      isTitle: true,
      searchable: true
    },
    {
      title: 'Email',
      key: 'email',
      isTagline: true,
      searchable: true
    },
    {
      title: 'Account type',
      key: 'account_type',
      isTagline: true,
      formatter: (value) => value || 'regular'
    },
    {
      title: 'Status',
      key: 'is_active',
      isTagline: true,
      formatter: (value) => (value ? 'Active' : 'Inactive')
    },
    {
      title: 'Date added',
      key: 'created_on',
      formatter: (value) => (value ? new Date(value).toDateString() : ''),
      isMetadata: true
    }
  ],
  items: [],
  search_key: 'email',
  search_text: 'Search users'
};
